import DynamicConfigSelectButton from './DynamicConfigSelectButton';

export default DynamicConfigSelectButton;
